import gql from "graphql-tag";

export const homeLocationFragment = gql`
  fragment HomeLocationFragment on HomeLocation {
    id
    longitude
    latitude
    name
    remarks
    warehouse {
      id
      name
    }
  }
`;
